import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { Component, Input, OnChanges, OnInit, Renderer2, RendererFactory2, SimpleChanges } from '@angular/core';
import { GlobalService } from 'app/global/global.service';
import { Block } from 'app/interfaces/blocks';
import { fieldBlocks, SelectedFieldEnum } from 'app/interfaces/fields.dto';
import 'jquery-ui-dist/jquery-ui';
import { FieldBlock } from '../content-tab/content-tab.dto';
import { ContentTabService } from '../content-tab/content-tab.service';
import { GeneralPopoverSettingsComponent } from '../general-popover-settings/general-popover-settings.component';
import { SelectedRole } from '../general-popover-settings/general-popover-settings.dto';
import { DomHelperService } from 'app/global/dom-helper.service';
import { EventHandlersService } from '../../edit-template/event-handler.service';


@Component({
  selector: 'app-pdf-block-settings',
  templateUrl: './pdf-block-settings.component.html',
  styleUrls: ['./pdf-block-settings.component.scss'],
  providers:[GeneralPopoverSettingsComponent]
})

export class PdfBlockSettingsComponent implements OnChanges, OnInit {
  
  @Input() data = [];
    
  public pdf_uuid: number = 0;
  public pdfBlock: Block;
  public role_id: number = 0;
  public fieldsBlock: FieldBlock[] = fieldBlocks();
  public rangeValue = 0.7;
  private renderer: Renderer2;
  public SelectedFieldEnum = SelectedFieldEnum;

  /**
   * Constructor
   * @param template 
   * @param globalService 
   * @param generalPopoverSettings
   * @param contentTabService 
   * @param rendererFactory 
   */
  constructor(
    private eventHandlersService: EventHandlersService,
    private globalService: GlobalService,
    private generalPopoverSettings: GeneralPopoverSettingsComponent,
    private contentTabService: ContentTabService,
    private domHelperService: DomHelperService,
    rendererFactory: RendererFactory2,
  ) { this.renderer = rendererFactory.createRenderer(null, null); }

  ngOnInit(): void {
    this.pdf_uuid = this.data['uuid'];
  }

  onDragStart() {}
  

  
  onDragEnd(event: CdkDragEnd) {
    const target = (event.event.target as HTMLElement);
    const pdfBlock = target.closest('.pdf-block');
    if(pdfBlock){
      const {top, left} = this.getOffset(pdfBlock as HTMLElement);
      const {pageX, pageY} = (event.event as MouseEvent);
      const type = event.source.data.field_block;
      const fieldType = event.source.data.type;
      this.contentTabService.addField(
        pageY - top - 15,
        pageX - left - 12 - 21,
        type,
        { pdfblock: pdfBlock.querySelector('.content-box-inner') },
        fieldType
      );
      this.domHelperService.initializeEventListener('.content-draggable-field', 'click', 'showFieldPopover');
    }
  }



  getOffset(element:HTMLElement){
    const bodyRect = document.body.getBoundingClientRect();
    const elemRect = element.getBoundingClientRect()
    const top = elemRect.top - bodyRect.top;
    const left = elemRect.left - bodyRect.left;
    return {top:top, left:left};
  }

  /**
   * Life cycle hook detech changes on component
   * @param changes 
   */
  async ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.pdf_uuid = changes['data'].currentValue['uuid'];
      this.pdfBlock = this.globalService.fields_data['blocks'][this.pdf_uuid];
      this.role_id = typeof this.pdfBlock != 'undefined' ? this.pdfBlock.role_id : 0;
      this.rangeValue = this.pdfBlock?.zoom ?? 0.6;
      await this.generalPopoverSettings.setupAllFields();
    }
  }


  /** Close Pdf block setting */
  clsoe() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }

  /**
  * select role for allow edit on signing area 
  */
  selectRole(role: SelectedRole) {
    this.pdfBlock = this.globalService.updateBlock(this.pdf_uuid, { role_id: role.id });
  }

  onRangeChange(event:MouseEvent){
    const editor = document.querySelector(`.editor${this.pdf_uuid}`);
    const value = (event.target as HTMLInputElement).value;
    this.pdfBlock = this.globalService.updateBlock(this.pdf_uuid, { zoom: value });
    this.rangeValue = parseInt(value);
    editor.querySelectorAll('.zoom').forEach((ele:HTMLElement) => {
      this.renderer.setStyle(ele, 'zoom', value);
    });
  }

}
